import React, {useEffect, useState} from 'react'
import {ICloud, cloudInitValues as initialValues} from '../../models/CloudModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import {useLocation, useNavigate} from 'react-router-dom'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {useIntl} from 'react-intl'
import HeaderCard from '../../../../../../components/Forms/HeaderCard'
import {Input} from '../../../../../../components/Forms/Input'

const API_URL = process.env.REACT_APP_API_URL || 'api'
const cloudSchema = Yup.object().shape({
  description: Yup.string().required('Campo obrigatório'),
  project_id: Yup.number().required('Campo obrigatório'),
  category_id: Yup.number().required('Campo obrigatório'),
  user_id: Yup.number().required('Campo obrigatório'),
  //descripton: Yup.string().required('Campo obrigatório'),
  // email: Yup.string().required('Campo obrigatório'),
})

const FormCloudEdit: React.FC = () => {
  const [loading, setLoading] = useState(false)
  const intl = useIntl()
  const location = useLocation()
  const MySwal = withReactContent(Swal)
  const navigate = useNavigate()
  const [uuid, setUuid] = useState('')

  useEffect(() => {
    if (location) {
      const {uuid} = location.state as ICloud
      setUuid(uuid || '')
      if (uuid) {
        getCloud(uuid)
      }
    }
    return () => {
      console.log('error')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  async function getCloud(uuid: string) {
    const {data} = await axios.get(API_URL + '/cloud/v1/files/datatable' + uuid)
    const cloud: ICloud = data.data
    if (cloud.uuid) {
      formik.setFieldValue('uuid', cloud.uuid)
    }
    if (cloud.description) {
      formik.setFieldValue('description', cloud.description)
    }
    if (cloud.project_id) {
      formik.setFieldValue('project_id', cloud.project_id)
    }
    if (cloud.category_id) {
      formik.setFieldValue('category_id', cloud.category_id)
    }
    if (cloud.user_id) {
      formik.setFieldValue('user_id', cloud.user_id)
    }

    return data
  }

  const data = new FormData()

  const formik = useFormik<ICloud>({
    initialValues,
    validationSchema: cloudSchema,
    onSubmit: async (values) => {
      setLoading(true)

      try {
        data.append('description', values.description)
        data.append('category_id', values.project_id.toString())
        data.append('user_id', values.project_id.toString())
        data.append('project_id', values.project_id.toString())

        data.set('file', values.file as File)

        await axios({
          method: 'post',
          url: API_URL + '/cloud/v1/files',
          data: data,
          headers: {'Content-Type': 'multipart/form-data'},
        })
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'ENTERPRISESTYPE.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/cloudfile')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'ENTERPRISESTYPE.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })

        setLoading(false)
      }
    },
  })
  function resetInputs() {
    formik.resetForm()
  }

  async function deleteCloud(uuid: string) {
    await axios
      .delete(API_URL + '/cloud/v1/files/' + uuid)
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'MEASUREMENT.SWAL_DELETE'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/cloud')
      })
      .catch(() => {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'MEASUREMENT.SWAL_DELETE_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })
      })
  }

  function deleteMsgCloud() {
    MySwal.fire({
      title: intl.formatMessage({id: 'MEASUREMENT.SWAL_DELETE_?'}),
      text: intl.formatMessage({id: 'COMMON.SWAL_DELETE_TEXT'}),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({id: 'COMMON.SWAL_DELETE_MSG'}),
      cancelButtonText: intl.formatMessage({id: 'COMMON.CANCEL_BUTTON'}),
    }).then((result) => {
      if (result.value) {
        deleteCloud(uuid)
      }
    })
  }

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    formik.setFieldValue('file', event.target.files![0])
  }

  return (
    <div className='card card-custom mt-n8'>
      {/* Component Header de Cadastros. */}
      <HeaderCard
        buttonBack={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})}
        title={intl.formatMessage({id: 'CLOUD.NEW_CLOUD'})}
        routeBack='/cloud'
      />

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            {/* INICIO DESCRIÇÃO ----------------------*/}

            <Input
              title={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
              placeholder={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
              {...formik.getFieldProps('description')}
              required
            />

            {/* FIM DESCRIÇÃO ------------------------------*/}

            {/* INICIO PROJECT ID */}

            <Input
              title={intl.formatMessage({id: 'CLOUD.INPUT_PROJECT_ID'})}
              placeholder={intl.formatMessage({id: 'CLOUD.INPUT_PROJECT_ID'})}
              {...formik.getFieldProps('project_id')}
              required
            />

            {/* FIM PROJECT ID */}

            {/* INICIO CATEGORY ID */}

            <Input
              title={intl.formatMessage({id: 'CLOUD.INPUT_CATEGORY_ID'})}
              placeholder={intl.formatMessage({id: 'CLOUD.INPUT_CATEGORY_ID'})}
              {...formik.getFieldProps('category_id')}
              required
            />

            {/* FIM CATEGORY ID */}

            {/* INICIO USER ID */}

            <Input
              title={intl.formatMessage({id: 'CLOUD.INPUT_USER_ID'})}
              placeholder={intl.formatMessage({id: 'CLOUD.INPUT_USER_ID'})}
              {...formik.getFieldProps('user_id')}
              required
            />

            {/* FIM USER ID */}

            {/* INICIO SVG FILE */}
            <label className='form-label required mt-5'>
              {intl.formatMessage({id: 'FILE.INPUT_CLOUD'})}
            </label>
            <input className='form-control form-control-sm' type='file' onChange={onChange} />
            {/* FIM SVG FILE */}

            <div className='d-flex justify-content-end py-6'>
              <button type='submit' className='btn btn-primary' disabled={loading}>
                {!loading && intl.formatMessage({id: 'COMMON.EDIT_BUTTON'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'COMMON.EDITING_BUTTON'})}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <button type='reset' onClick={resetInputs} className='btn btn-secondary mx-2'>
                {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
              </button>

              <button
                type='button'
                onClick={deleteMsgCloud}
                className='btn btn-outline btn-outline-danger btn-active-danger ml-3'
              >
                {intl.formatMessage({id: 'COMMON.DELETE_BUTTON'})}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {FormCloudEdit}
